export const STEPS = ['lyrics', 'music', 'video'];

export const COSTS = {
  lyrics: 1,
  music: 2,
  video: 5,
};

export const OPTIONS = {
  mood: [
    { value: 'warm', label: 'Warm' },
    { value: 'happy', label: 'Happy' },
    { value: 'romantic', label: 'Romantic' },
    { value: 'sad', label: 'Sad' },
  ],
  language: [
    { value: 'auto', label: 'Auto' },
    { value: 'Simplified Chinese', label: 'Chinese' },
    { value: 'English', label: 'English' },
  ],
  style: [
    { value: 'pop', label: 'Pop' },
    { value: 'acoustic', label: 'Acoustic' },
    { value: 'lo-fi', label: 'Lo-fi' },
    { value: 'rock', label: 'Rock' },
  ],
  vocal: [
    { value: 'female', label: 'Female vocal' },
    { value: 'male', label: 'Male vocal' },
    { value: 'duet', label: 'Duet' },
    { value: 'instrumental', label: 'Instrumental' },
  ],
  duration: [
    { value: '30', label: '30 seconds' },
    { value: '60', label: '60 seconds' },
    { value: '120', label: '120 seconds' },
    { value: '180', label: '180 seconds' },
  ],
  imageMode: [
    { value: 'songwriting', label: 'Songwriting' },
    { value: 'atmosphere', label: 'Atmosphere' },
    { value: 'clip', label: 'Clip' },
  ],
  tempo: ['Slow', 'Medium', 'Fast'],
  ratio: ['9:16', '16:9', '1:1'],
  resolution: ['720p', '1080p', '2K'],
  visual: ['Cinematic', 'Vlog', 'Anime', 'Dreamy'],
};

export const AUDIO_VALUE_MAPS = {
  mood: {
    Warm: 'warm',
    Happy: 'happy',
    Romantic: 'romantic',
    Sad: 'sad',
  },
  language: {
    Chinese: 'Simplified Chinese',
    English: 'English',
    Mixed: 'auto',
  },
  style: {
    Pop: 'pop',
    Acoustic: 'acoustic',
    'Lo-fi': 'lo-fi',
    Rock: 'rock',
  },
  vocal: {
    'Female vocal': 'female',
    'Male vocal': 'male',
    Duet: 'duet',
    Instrumental: 'instrumental',
  },
};

export function createLyrics(idea) {
  const theme = idea.trim() || 'a small bright memory';
  return [
    { title: 'Verse 1', lines: [
      `I kept the light from ${theme},`,
      'Small moments moving like a golden train.',
      'Every laugh became a road back home,',
      'Every frame still calling out my name.',
    ] },
    { title: 'Chorus', lines: [
      'Turn it up, let the heart replay,',
      'All our colors in the afterglow.',
      'If tomorrow feels far away,',
      'This song will know where we should go.',
    ] },
    { title: 'Bridge', lines: [
      'Hold the scene, let the night stay bright,',
      'We are stories written into light.',
    ] },
  ];
}

export function parseLyrics(raw) {
  const sections = [];
  let title = 'Verse';
  let lines = [];
  const flush = () => {
    if (!lines.length) return;
    sections.push({ title, lines: [...lines] });
    lines = [];
  };
  String(raw || '').split('\n').forEach((line) => {
    const text = line.trim();
    if (!text) return;
    const sectionTitle = extractSectionTitle(text);
    if (sectionTitle) {
      flush();
      title = sectionTitle;
      return;
    }
    addLyricLine(lines, text);
  });
  flush();
  return sections;
}

function extractSectionTitle(text) {
  let body = text.trim();
  const wrapped = body.match(/^[[(（【]\s*(.*?)\s*[\])）】]\s*[:：]?$/);
  body = wrapped ? wrapped[1].trim() : body.replace(/\s*[:：]$/, '');
  const match = body.match(/^(pre[-\s]?chorus|post[-\s]?chorus|verse|chorus|bridge|outro|intro|hook|refrain|interlude|rap|prelude|主歌|副歌|桥段|橋段|过门|過門|间奏|間奏|前奏|尾奏|结尾|結尾)(?:\s*([0-9一二三四五六七八九十]+))?$/i);
  if (!match) return '';
  return formatSectionTitle(match[1], match[2]);
}

function formatSectionTitle(kind, number) {
  const key = kind.toLowerCase().replace(/\s+/g, '-');
  const names = {
    verse: 'Verse', chorus: 'Chorus', bridge: 'Bridge', outro: 'Outro',
    intro: 'Intro', hook: 'Hook', refrain: 'Refrain', interlude: 'Interlude',
    rap: 'Rap', prelude: 'Prelude', 'pre-chorus': 'Pre-Chorus',
    prechorus: 'Pre-Chorus', 'post-chorus': 'Post-Chorus',
    postchorus: 'Post-Chorus', 主歌: 'Verse', 副歌: 'Chorus',
    桥段: 'Bridge', 橋段: 'Bridge', 过门: 'Interlude', 過門: 'Interlude',
    间奏: 'Interlude', 間奏: 'Interlude', 前奏: 'Intro',
    尾奏: 'Outro', 结尾: 'Outro', 結尾: 'Outro',
  };
  return `${names[key] || kind}${number ? ` ${number}` : ''}`;
}

function addLyricLine(lines, text) {
  if (/^[,.;:!?，。！？、；：…]+$/.test(text)) {
    if (lines.length) lines[lines.length - 1] = `${lines[lines.length - 1]}${text}`;
    return;
  }
  lines.push(text);
}

export function composeLyrics(sections) {
  return sections.map((section) => (
    [`[${section.title}]`, ...section.lines].join('\n')
  )).join('\n\n');
}
